export default __webpack_public_path__ + "static/media/weatherDashboard.6356219d.png";